/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useEffect, useState } from "react";
import HeaderSection from "../../../common/headerSection";
import PageHeader from "../../../common/pageHeader";
import { areaService } from "../../../../service/areaServices";
import { userService } from "../../../../service/plateServices";
import Select, { ActionMeta, SingleValue } from "react-select";
import { visualInspection } from "../../../../service/visualinspection";
import baseUrl from "../../../../service";
import { useTranslation } from "react-i18next";
import CustomTable from "../../../../widgets/table";
import Pagination from "../../../../widgets/pagination";
import { activeSamplingColumns } from "./partials/columns";
import { reportServices } from "../../../../service/reportServices";
import { DEFAULT_PAGE_SIZE } from "../../../../constants/constants";
import AlertModal from "../../../../widgets/alertModal";
import CustomToast from "../../../../widgets/toaster";
import { scheduleService } from "../../../../service/scheduleService";
import { authToken } from "../../../../service/axiosConfig";
import { userService as userServices } from "../../../../service/userService";

interface ActiveAirSamplingReportProps {
  ishide?: boolean;
  filter?:any
}

const ActiveAirSamplingReport: React.FC<ActiveAirSamplingReportProps> = ({
  ishide,
  filter = {}
}) => {
  type Filters = {
    location: string;
    batchCode: string;
    lotCode: string;
    plateSerialNumber: string;
    fromDate: string;
    toDate: string;
    area: string;
    productionSchedule: string;
    productName: string;
  };
  type OptionType = {
    value: string;
    label: string;
  };

  const { t } = useTranslation();

  const [filters, setFilters] = useState<Filters>({
    location: filter.location || "",
    batchCode: filter.batchCode || "",
    lotCode: filter.lotCode || "",
    plateSerialNumber: "",
    fromDate: filter.fromDate || "",
    toDate: filter.toDate || "",
    area: filter.area || "",
    productionSchedule: filter.productionSchedule || "",
    productName: filter.productName || "",
  });
  const [areas, setAreas] = useState<Array<any>>([]);
  const [locations, setLocations] = useState<Array<any>>([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [plateBatches, setPlateBatches] = useState([]);
  const [lotcode, setLotCode] = useState([]);
  const [plateSerielNum, setPlateSerielNums] = useState([]);
  const [showDownloadCSV, setShowDownloadCSV] = useState(true);
  const [isApplyClicked, setIsApplyClicked] = useState(true);
  const [plateDetails, setPlateDetails] = useState<Array<any>>([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [useEffectRequired, setUseEffectRequired] = useState(false);
  const [keyWord, setkeyWord] = useState("");
  const [batchCode, setBatchCode] = useState("");
  const [authUserID, setAuthUserID] = useState("");
  const [sort, setSort] = useState("id");
  const [order, setOrder] = useState("desc");
  const [pdfDownload, setpdfDownload] = useState(false);
  const [toDateConstraints, setToDateConstraints] = useState({
    min: "",
    max: "",
  });
  const [isToDateEnabled, setIsToDateEnabled] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("");
  const [areaList, setAreaList] = useState<Array<any>>([]);
  const [prodScheduleList, setProdScheduleList] = useState<Array<any>>([]);
  const [productList, setProductList] = useState<Array<any>>([]);
  const [areaId, setAreaId] = useState("");
  const [scheduleProductId, setScheduleProductId] = useState("");
  const [productId, setProductId] = useState("");
  const [userId, setUserId] = useState("");
  const [permission, setPermission] = useState<string[]>([]);
  const sortRemoveList = [
    "slno",
    "production_schedule",
    "product_name",
    "lot_code",
    "sampling_duration",
    "incubation_started_by",
    "incubation_start_date",
    "incubation_end_by",
    "incubation_end_date",
    "incubation_duration",
    "incubation2_started_by",
    "incubation2_start_date",
    "incubation2_end_by",
    "incubation2_end_date",
    "incubation2_duration",
    "observer1_name",
    "count1",
    "observer2_name",
    "count2",
    "approved_id",
    "observer3_name",
    "count3",
  ];

  // Function to fetch locations based on area
  const fetchLocationsByArea = async (areaId: string) => {
    if (!areaId) {
      setLocations([]);
      setFilters(prev => ({ ...prev, location: "" }));
      return;
    }
    
    try {
      const response = await areaService.getParentAreaList([11], areaId); // 11 is the type for locations
      if (response.status && response.statusCode === 200) {
        const locationData = Array.isArray(response.data) 
          ? response.data.map((item: any) => ({
              id: item.id,
              title: item.name
            }))
          : [];
        setLocations(locationData);
        // Reset location when area changes
        setFilters(prev => ({ ...prev, location: "" }));
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
      setLocations([]);
    }
  };

  const handleChange = (
    eventOrValue:
      | React.ChangeEvent<HTMLSelectElement | HTMLInputElement>
      | SingleValue<OptionType>,
    actionOrUndefined?: ActionMeta<OptionType>
  ) => {
    let newFilters: Filters;
    let areaChanged = false;
    let areaId = "";

    if (actionOrUndefined) {
      // For react-select
      const { name } = actionOrUndefined as { name: string };
      if (name === "batchCode") {
        lotCode((eventOrValue as SingleValue<OptionType>)?.value || "");
      }

      // newFilters = {
      //   ...filters,
      //   [name]: (eventOrValue as SingleValue<OptionType>)?.value || "",
      // };

      const value = (eventOrValue as SingleValue<OptionType>)?.value || "";
      newFilters = {
        ...filters,
        [name]: value,
      };

      // If area is changed, fetch locations for that area
      if (name === "area") {
        areaChanged = true;
        areaId = value;
        fetchLocationsByArea(areaId);
      }
    } else {
      // For native select and input elements
      const { name, value } = (
        eventOrValue as React.ChangeEvent<HTMLSelectElement | HTMLInputElement>
      ).target;
      newFilters = { ...filters, [name]: value };

      if (name === "toDate" && value === "") {
        setToDateConstraints({
          min: "",
          max: "",
        });
        newFilters = { ...filters, ["fromDate"]: "", ["toDate"]: "" };
      }
    }

    setFilters(newFilters);

    // Enable button if any filter is changed
    const anyFilterChanged = Object.values(newFilters).some(
      (val) => val !== ""
    );
    setIsButtonDisabled(!anyFilterChanged);
    setIsApplyClicked(false);
    setShowDownloadCSV(true);
  };

  const geAreaTypeList = async () => {
    try {
      const response = await areaService.getParentAreaList([11]);
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  slno: index + 1,
                  policy_id: element.policy_id,
                  id: element.id,
                  title: element.name,
                };
              }
            );
            setAreas(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  const handleSort = (key: string, value: boolean) => {
    setSort(key);
    if (value) {
      setOrder("asc");
    } else {
      setOrder("desc");
    }
    setUseEffectRequired(true);
  };

  //batch list for filter dropdown
  const listPlateBatch = async () => {
    try {
      const response = await userService.listPlateBatch();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  value: element.batch_number,
                  label: element.batch_number,
                };
              }
            );
            setPlateBatches(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.error("Plate response", error);
    }
  };

  const lotCode = async (batchNo: string) => {
    try {
      const response = await visualInspection.listFilterLots(batchNo);
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  value: element.id,
                  label: element.lot_code,
                };
              }
            );
            setLotCode(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.error("Plate response", error);
    }
  };

  const listSerialNumber = async () => {
    try {
      const response = await userService.listSerialNumber();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  value: element.serial_number,
                  label: element.serial_number,
                };
              }
            );
            setPlateSerielNums(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.error("Plate response", error);
    }
  };

  const handleApplyClick = () => {
    setShowDownloadCSV(false);
    setIsApplyClicked(true);
    // setUseEffectRequired(true)
    //getActiveSamplingPlateReport();
    // listAuditTrialReport();
  };

  const handleCancel = () => {
    const initialFormData = {
      location: "",
      batchCode: "",
      lotCode: "",
      plateSerialNumber: "",
      fromDate: "",
      toDate: "",
      area: "",
      productionSchedule: "",
      productName: "",
    };
    setToDateConstraints({
      min: "",
      max: "",
    });
    setIsToDateEnabled(false);
    setShowDownloadCSV(true);

    setFilters(initialFormData);
    setUseEffectRequired(true);
    // listAuditTrialReport();
  };

  //api call to list active samling report
  const getActiveSamplingPlateReport = async () => {
    setPlateDetails([
      {loading: true},
    ]);
    try {
      const response = await reportServices.activeSamplingReport(
        page,
        pageSize,
        filters.fromDate,
        filters.toDate,
        filters.location,
        filters.batchCode,
        filters.lotCode,
        filters.plateSerialNumber,
        sort,
        order,
        filters.area,
        filters.productionSchedule,
        filters.productName
      );
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            setTotalPages(response?.totalPages);
            setTotalElements(response?.totalElements);
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                const statusNumber = parseInt(element.location_type, 10);
                return {
                  id: element.id,
                  slno: index + 1,
                  area: element.area_name,
                  location: element.location,
                  serial_number: element.plate_serial,
                  batch_number: element.batch_number,
                  lot_code: element.lot_code,
                  area_code: element.equipment_id,
                  start_date_time: element.sampling_start_date,
                  sampling_started_by: element.sampling_started_by,
                  activity_end_date_time: element.activity_end_date_time,
                  sampling_duration: element.sampling_duration,
                  incubation_started_by: element.incubation_started_by,
                  incubation_start_date: element.incubation_start_date,
                  incubation_end_by: element.incubation_end_by,
                  incubation_end_date: element.incubation_end_date,
                  incubation_duration: element.incubation_duration,
                  incubation2_started_by: element.incubation2_started_by,
                  incubation2_start_date: element.incubation2_start_date,
                  incubation2_end_by: element.incubation2_end_by,
                  incubation2_end_date: element.incubation2_end_date,
                  incubation2_duration: element.incubation2_duration,
                  observer1_name: element.observer1_name,
                  observer2_name: element.observer2_name,
                  observer3_name: element.observer3_name,
                  count1: element.count1,
                  count2: element.count2,
                  count3: element.count3,
                  approved_id: element.approved_id,
                  product_name: element.product_name,
                  production_schedule: element.production_schedule_name,
                };
              }
            );
            setPlateDetails(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setPlateDetails([]);
        setTotalPages(0);
        setTotalElements(0);
      }
    } catch (error) {
      console.error("Plate response", error);
    }
  };

  useEffect(() => {
    var storedData = localStorage.getItem("userDetails");

    if (storedData) {
      var storedObject = JSON.parse(storedData);
      setAuthUserID(storedObject[0].x_userid);
      setUserId(storedObject[0].id);
      // Get permissions when component mounts
      getPermissionByRole(storedObject[0].role_master_id);
    }

    getAreaList();
    getProductionSchedules();
    getProductList();

    getActiveSamplingPlateReport();
    //geAreaTypeList();
    listPlateBatch();
    listSerialNumber();
    setUseEffectRequired(false);
  }, [useEffectRequired]);

  useEffect(() => {
    if (isApplyClicked) {
      getActiveSamplingPlateReport();
    }
  }, [page, pageSize, sort, order, isApplyClicked]);
  

  const getAreaList = async () => {
    try {
      const response = await scheduleService.getAreaList("id", "desc", "6,17");
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  id: element.id,
                  name: element.name,
                  grade_name: element.grade_name,
                };
              }
            );
            setAreaList(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setAreaList([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  // get ProductionScheduleList
  const getProductionSchedules = async () => {
    try {
      const response = await scheduleService.getProductionSchedulesReport();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  slno: index + 1,
                  id: element.id,
                  production_schedule_name: element?.production_schedule_name,
                  activity_type_id: element.activity_type_id,
                };
              }
            );
            setProdScheduleList(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setProdScheduleList([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  //api call to get area list
  const getProductList = async () => {
    try {
      const response = await scheduleService.getProductList();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  id: element.id,
                  name: element.name,
                };
              }
            );
            setProductList(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setProductList([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  const getPermissionByRole = async (role : number) => {
      try {
        const response = await userServices.getPermissionByRole(role);
        if(response.status && response.statusCode === 200){
          setPermission(response.data.permissions)
        }
      } catch (error) {
        console.error(error);
      }
    }
  

  const handleFilter = (key: string, value: any) => {
    if (key === "search") {
      setkeyWord(value);
    } else if (key === "area") {
      setAreaId(value);
    } else if (key === "productionSchedule") {
      setScheduleProductId(value);
    } else if (key === "productName") {
      setProductId(value);
    }

    setUseEffectRequired(true);
  };

  const downloadAuditCSV = async () => {
    try {
      const url = `${baseUrl}/summary/air_sampling?sort=id&order=desc&area_master_id=${filters.location}&batch_number=${filters.batchCode}&lot_id=${filters.lotCode}&serial_number=${filters.plateSerialNumber}&from_date=${filters.fromDate}&to_date=${filters.toDate}&auth_id=${authUserID}&schedule_production_id=${filters.productionSchedule}&product_id=${filters.productName}&area_id=${filters.area}&is_completed=`;

      const res = await fetch(url, {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID,
          'Content-Type': 'application/json'
        }
      });
      
      const response = await res.json();

      if (res.ok && response.statusCode === 200) {
        setToastType("success");
        setToastMessage(response.message || "Downloaded successfully");
        // Disable the button after successful download
        setShowDownloadCSV(true);
      } else {
        setToastType("error");
        setToastMessage(response.message || "Something went wrong");
      }
      setShowToast(true);
    } catch (error) {
      setToastType("error");
      setToastMessage("Failed to fetch air sampling summary");
      setShowToast(true);
    }
  };

  const handlePageChange = (newPage: any, pageSize?: number) => {
  setPage(newPage);
  if (pageSize) {
    setPageSize(pageSize);
  }
};

  const formatDateTime = (date: string | Date): string => {
    if (!date) return "";
    const d = new Date(date);
    return (
      d.getFullYear() +
      "-" +
      String(d.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(d.getDate()).padStart(2, "0") +
      "T" +
      String(d.getHours()).padStart(2, "0") +
      ":" +
      String(d.getMinutes()).padStart(2, "0")
    );
  };

  return (
    <div>
      <CustomToast
        show={showToast}
        onClose={() => setShowToast(false)}
        delay={5000}
        message={toastMessage}
        toastType={toastType}
      />
      {/* {!ishide && (
        <>
          <HeaderSection />
          <PageHeader pageHeader="Active Sampling Report" />
        </>
      )} */}
      {ishide && (
      <div className="filter-component">
        <div className="filter-row">
          <label htmlFor="productionScheduleSelect" className="filterLabelLeft">
            Production Schedule
          </label>
          <div style={{ zIndex: "9" }}>
            <Select
              options={prodScheduleList.map((schedule) => ({
                value: schedule.id,
                label: schedule.production_schedule_name,
              }))}
              onChange={(selectedOption, actionMeta) =>
                handleChange(
                  selectedOption as SingleValue<OptionType>,
                  actionMeta as ActionMeta<OptionType>
                )
              }
              placeholder="Select"
              isSearchable={true}
              isClearable
              value={
                prodScheduleList.find(
                  (option: any) => option.id === filters.productionSchedule
                )
                  ? {
                      value: filters.productionSchedule,
                      label: prodScheduleList.find(
                        (opt) => opt.id === filters.productionSchedule
                      )?.production_schedule_name,
                    }
                  : null
              }
              name="productionSchedule"
            />
          </div>
        </div>

        <div className="filter-row">
          <label htmlFor="productNameSelect" className="filterLabelLeft">
            Product Name
          </label>
          <div style={{ zIndex: "8" }}>
            <Select
              options={productList.map((product) => ({
                value: product.id,
                label: product.name,
              }))}
              onChange={(selectedOption, actionMeta) =>
                handleChange(
                  selectedOption as SingleValue<OptionType>,
                  actionMeta as ActionMeta<OptionType>
                )
              }
              placeholder="Select"
              isSearchable={true}
              isClearable
              value={
                productList.find(
                  (option: any) => option.id === filters.productName
                )
                  ? {
                      value: filters.productName,
                      label: productList.find(
                        (opt) => opt.id === filters.productName
                      )?.name,
                    }
                  : null
              }
              name="productName"
            />
          </div>
        </div>

        <div className="filter-row">
          <label htmlFor="areaSelect" className="filterLabelLeft">
            Area
          </label>
          <div style={{ zIndex: "7" }}>
            <Select
              options={areaList.map((area) => ({
                value: area.id,
                label: area.name,
              }))}
              onChange={(selectedOption, actionMeta) =>
                handleChange(
                  selectedOption as SingleValue<OptionType>,
                  actionMeta as ActionMeta<OptionType>
                )
              }
              placeholder="Select"
              isSearchable={true}
              isClearable
              value={
                areaList.find((option: any) => option.id === filters.area)
                  ? {
                      value: filters.area,
                      label: areaList.find((opt) => opt.id === filters.area)
                        ?.name,
                    }
                  : null
              }
              name="area"
            />
          </div>
        </div>
        <div className="filter-row">
          <label className="filter-label">
            Location
            <select
              name="location"
              value={filters.location}
              onChange={handleChange}
              className="filter-select"
              disabled={!filters.area}
            >
              {/* <option value="">Select</option>
              {areas?.map((obj, index) => (
                <option key={index} value={obj?.id}>
                  {obj?.title}
                </option> */}
              <option value="">Select</option>
              {locations?.map((location, index) => (
                <option key={index} value={location?.id}>
                  {location?.title}
                </option>
              ))}
            </select>
          </label>
        </div>
        <div className="filter-row">
          <label htmlFor="areaTypeSelect" className="filterLabelLeft">
            Batch Code
          </label>
          <div style={{ zIndex: "6" }}>
            <Select
              options={plateBatches}
              onChange={(selectedOption, actionMeta) =>
                handleChange(
                  selectedOption as SingleValue<OptionType>,
                  actionMeta as ActionMeta<OptionType>
                )
              }
              placeholder="Select"
              isSearchable={true}
              isClearable
              value={
                plateBatches.find(
                  (option: any) => option.value === filters.batchCode
                ) || null
              }
              name="batchCode"
            />
          </div>
        </div>

        {/* <div className="filter-row">
      <label htmlFor="areaTypeSelect" className='filterLabelLeft'>Lot Code</label> 
        <div style={{ zIndex: '10' }}>
          <Select
            options={lotcode}
            onChange={(selectedOption, actionMeta) => handleChange(selectedOption as SingleValue<OptionType>, actionMeta as ActionMeta<OptionType>)}
            placeholder="Lot Code"
            isSearchable={true}
            isClearable
            value={lotcode.find((option: any) => option.value === filters.lotCode) || null}
            name="lotCode"
          />
        </div>        
      </div> */}

        {/* <div className="filter-row">
      <label htmlFor="areaTypeSelect" className='filterLabelLeft'>Serial Number</label> 
        <div style={{ zIndex: '10' }}>
          <Select
            options={plateSerielNum}
            onChange={(selectedOption, actionMeta) => handleChange(selectedOption as SingleValue<OptionType>, actionMeta as ActionMeta<OptionType>)}
            placeholder="Serial Number"
            isSearchable={true}
            isClearable
            value={plateSerielNum.find((option: any) => option.value === filters.plateSerialNumber) || null}
            name="plateSerialNumber"
          />
        </div>        
      </div> */}

        <div className="filter-row">
          <label className="filter-label">
            <span>From Date<span style={{ color: "red" }}>*</span></span>
            {/* From Date */}
            <input
              type="datetime-local"
              name="fromDate"
              value={formatDateTime(filters.fromDate)}
              onChange={(e) => {
                handleChange(e);
                const fromDate = new Date(e.target.value);
                // if (!isNaN(fromDate.getTime())) {
                //   // Calculate the min and max for the toDate field
                //   // const minDate = new Date(fromDate);
                //   // const maxDate = new Date(fromDate);
                //   // maxDate.setDate(maxDate.getDate() + 14);

                //   // // Update state with min and max dates
                //   // setToDateConstraints({
                //   //   min: formatDateTime(minDate),
                //   //   max: formatDateTime(maxDate),
                //   // });

                //   setFilters((prevData) => ({
                //     ...prevData,
                //     fromDate: formatDateTime(fromDate),
                //     //toDate: formatDateTime(minDate),
                //     //toDate: formatDateTime(fromDate),
                //   }));
                //   setIsToDateEnabled(true);
                // }
                if (!isNaN(fromDate.getTime())) {
                  // Set the minimum allowed date for toDate to be the selected fromDate
                  setToDateConstraints({
                    min: e.target.value,
                    max: ""
                  });

                  setFilters(prevData => ({
                    ...prevData,
                    fromDate: formatDateTime(fromDate),
                    // Reset toDate if it's before the new fromDate
                    ...(prevData.toDate && new Date(prevData.toDate) < fromDate && { toDate: "" })
                  }));
                  
                  setIsToDateEnabled(true);
                }
              }}
              className="filter-input"
              onKeyDown={(e) => {
                const allowedKeys = ["Tab", "Enter", "Escape"];
                if (!allowedKeys.includes(e.key)) {
                  e.preventDefault();
                }
              }}
              onPaste={(e) => e.preventDefault()}
            />
          </label>
        </div>

        <div className="filter-row">
          <label className="filter-label">
          <span>To Date<span style={{ color: "red" }}>*</span></span>
          {/* To Date */}
            <input
              type="datetime-local"
              name="toDate"
              value={formatDateTime(filters.toDate)}
              onChange={handleChange}
              min={toDateConstraints.min}
              max={toDateConstraints.max}
              disabled={!isToDateEnabled}
              className="filter-input"
              onKeyDown={(e) => {
                const allowedKeys = ["Tab", "Enter", "Escape"];
                if (!allowedKeys.includes(e.key)) {
                  e.preventDefault();
                }
              }}
              onPaste={(e) => e.preventDefault()}
            />
          </label>
        </div>

        {/* <div className="filter-row">
        <button className="filter-button" disabled={isButtonDisabled} onClick={downloadAuditCSV}>Download Active Air Sampling Report</button>
      </div> */}
      </div>

      )}
{ishide && (
      <div className="mx-2 d-flex justify-content-end">
        {/* <button className="filter-button" disabled={isButtonDisabled} onClick={downloadAuditCSV}>Download Active Air Sampling Report</button> */}

        <button
          className="analyticalFilterClose"
          title="Click here to Reset Filter"
          onClick={handleCancel}
        >
          {t("buttons.cancel")}
        </button>
        <button
          className={
            isApplyClicked
              ? "analyticalFilterApplyDisabledDownload"
              : "analyticalFilterApply"
          }
          disabled={isApplyClicked}
          onClick={handleApplyClick}
          title="Click here to Apply Filter"
        >
          {t("buttons.apply")}
        </button>
        {permission.includes("generate_report") && (
          <button
            // className={
            //   showDownloadCSV
            //     ? "analyticalFilterDisabledDownload"
            //     : "analyticalFilterDownload"
            // }
            // disabled={showDownloadCSV}
            className={showDownloadCSV || plateDetails.length === 0 ? "analyticalFilterDisabledDownload" : "analyticalFilterDownload"}
            disabled={showDownloadCSV || plateDetails.length === 0}
             onClick={() => {
            if (!filters.fromDate || !filters.toDate) {
              setToastMessage("Select a Date Range to Generate Report.");
              setToastType("error");
              setShowToast(true);
            } else {
              downloadAuditCSV();
            }
          }}
            title="Click here to Generate Report"
          >
            {"Generate Report"}
          </button>

          
        )}
      </div>
)}
      <div className=" mx-3 pe-2" style={{ height: "45vh" }}>
        <CustomTable
          data={plateDetails}
          columns={activeSamplingColumns}
          isEditable={false}
          totalElements={totalElements}
          isActionVisible={false}
          isViewVisible={false}
          isSeachable={false}
          tableHead={"Active Air Sampling Report"}
          showBatchFilter={false}
          showLotCodeFilter={false}
          onSortClick={handleSort}
          removeSortList={sortRemoveList}
          onFilterClick={handleFilter}
          // prodScheduleList={prodScheduleList}
          // productList={productList}
          // areaDropList={areaList}
        />
      </div>
      <div>
        <Pagination
          page={page}
          totalPages={totalPages}
          handlePageChange={handlePageChange}
        />
      </div>

      <AlertModal
        show={pdfDownload}
        onHide={() => setpdfDownload(false)}
        title="Alert"
        message={t("downloadPdf.download")}
        onConfirm={downloadAuditCSV}
      />
    </div>
  );
};

export default ActiveAirSamplingReport;
